<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useUserStore } from './stores/user'
import { getToken } from './utils/auth'

// 获取用户信息
const userStore = useUserStore()
if (getToken()) {
  userStore.getUserInfoHandler()
}
</script>

<template>
  <RouterView />
</template>
